import "./SolutionSection.scss";

const SolutionSection = () => {
  const solutionsData = [
    {
      id: 1,
      number: "02.",
      arrow: "/LandingPageImages/arrow.svg",
      image: "/LandingPageImages/ExamApplication.svg",
      title: "Exam Application",
      description:
        "Apply for exams with complete transparency. Track your application status in real-time.",
    },
    {
      id: 2,
      number: "03.",
      arrow: "/LandingPageImages/arrow.svg",
      image: "/LandingPageImages/SecureExamination.svg",
      title: "Secure Examination",
      description:
        "Take exams with confidence knowing every question is protected by blockchain technology.",
    },
    {
      id: 3,
      number: "04.",
      arrow: "/LandingPageImages/arrow.svg",
      image: "/LandingPageImages/VerifiedResults.svg",
      title: "Verified Results",
      description:
        "Receive blockchain-verified certificates that employers and institutions trust worldwide.",
    },
    {
      id: 4,
      number: "05.",
      arrow: "/LandingPageImages/arrow.svg",
      image: "/LandingPageImages/Career-ReadyCredentials.svg",
      title: "Career-Ready Credentials",
      description:
        "Share your verified certificates instantly with employers and institutions for seamless verification and global trust.",
    },
  ];

  return (
    <section className="solution-section">
      <div className="solution-background">
        <div className="">
          {/* Hero Section */}
          <div className="solution-hero">
            <div className="solution-hero-left">
              <h3 className="solution-benefit-heading">How Students Benefit</h3>
              <p className="solution-benefit-description">
                Revolutionary blockchain technology ensures every exam is
                tamper-proof, transparent, and trustworthy. Your future is
                secure with us.
              </p>
            </div>
            <div className="solution-hero-right">
              <h2 className="solution-title">
                <span className="solution-title-highlight">EduBlock Pro:</span>{" "}
                The Complete Solution
              </h2>
              <div className="solution-hero-left-mobile">
                <div className="solution-hero-arrow">
                  <img src="/LandingPageImages/arrow.svg" alt="arrow" />
                  <p>01.</p>
                </div>
                <img
                  src="/LandingPageImages/SimpleRegistration.png"
                  alt="The Complete Solution"
                />
                <div className="solution-hero-left">
                  <h3 className="solution-benefit-heading">
                    Simple Registration
                  </h3>
                  <p className="solution-benefit-description">
                    Register online with biometric verification. Your identity
                    is secured from day one.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Features Grid */}
          <div className="solutions-grid">
            {solutionsData.map((item) => (
              <div className="solution-feature-card" key={item.id}>
                <div className="solution-hero-arrow">
                  <img src={item.arrow} alt="arrow" />
                  <p>{item.number}</p>
                </div>

                <img src={item.image} alt={item.title} />

                <div className="solution-hero-left">
                  <h3 className="solution-benefit-heading sdrfhdfgh">{item.title}</h3>
                  <p className="solution-benefit-description">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
